module.exports = __webpack_public_path__ + "assets/img/index_innews_bg.c356a770.png";